// Same idea as mergeMedicineList: build the blog list for a given language
// as the full English list, with any translated post upserted over its
// English original (matched via blogDetectorId -> English post's own _id).
// Untranslated posts fall back to the English version instead of being
// omitted from the blog list entirely.
export function mergeBlogList(blogs, langId, englishLangId) {
  if (!blogs || blogs.length === 0) return [];

  const enBlogs = blogs.filter((b) => b.langId === englishLangId);
  if (!langId || langId === englishLangId) return enBlogs;

  const merged = enBlogs.map((en) => ({
    ...en,
    blogDetectorId: en.blogDetectorId || en._id,
  }));

  const indexById = new Map(merged.map((en, i) => [en._id, i]));
  const localized = blogs.filter((b) => b.langId === langId);
  localized.forEach((loc) => {
    const idx = indexById.get(loc.blogDetectorId);
    if (idx !== undefined) merged[idx] = { ...loc, _id: merged[idx]._id };
  });

  return merged;
}
